<template>
  <b-button variant="primary" type="submit" class="btn btn-fill float-right"><font-awesome-icon v-if="isLoading" icon="spinner" spin /> <font-awesome-icon v-else icon="save"/> {{ isCreate ? (state === 1 ? 'Save' : 'Saving..') : (state === 1 ? 'Update' : (state === 2 ? 'Updating..' : 'Fetching..')) }}</b-button>
</template>
<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      isCreate: {
        type: Boolean,
        required: false,
        default: false
      },
      state: {
        type: Number,
        required: false,
        default: 1
      },
      isLoading: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Buttons/SaveData.vue